var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertDeposit = function SvgAlertDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.66669V10.1263L6.35348 8.97984C6.15822 8.78458 5.84171 8.78458 5.64645 8.97984C5.45118 9.1751 5.45118 9.49161 5.64645 9.68687L7.64645 11.6869L7.68421 11.7214C7.88059 11.8816 8.17041 11.8699 8.35348 11.6869L10.3535 9.68687C10.5487 9.49161 10.5487 9.1751 10.3535 8.97984C10.1582 8.78458 9.84171 8.78458 9.64645 8.97984L8.49996 10.1263V4.66669C8.49996 4.39055 8.2761 4.16669 7.99996 4.16669C7.72382 4.16669 7.49996 4.39055 7.49996 4.66669Z",
    fill: "currentColor"
  })));
};
export default SvgAlertDeposit;